import state from './moduleStockOrderState.js'
import mutations from './moduleStockOrderMutations.js'
import actions from './moduleStockOrderActions.js'
import getters from './moduleStockOrderGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

